module.exports = __webpack_public_path__ + "img/camel-comb2-1.1daf12d8.jpg";